import { Box } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'

import { VonqImportedContracts } from 'modules/ats/components/VonqImportedContracts'
import { JobPostingLayout } from 'modules/ats/components/job_postings/JobPostingLayout'
import { useAtsContext } from 'modules/ats/lib/atsContext'
import { useJobDetailsContext } from 'modules/ats/pages/JobsPage/JobDetails'
import { useGetMarketplaceCompanyInstallations } from 'modules/marketplace/hooks/integrations/companyInstallations/useGetMarketplaceCompanyInstallations'
import { useGetMarketplaceIntegrations } from 'modules/marketplace/hooks/integrations/useGetMarketplaceIntegrations'
import integrationCodes from 'modules/marketplace/lib/integrationCodes'

import { JobBoards } from './JobBoards'
import { OpenPositions } from './OpenPositions'
import { VonqCampaigns } from './VonqCampaigns'
import { AtsIntegrations, hasJobBoards } from './utils'

const JobPostingPromotion = () => {
  const { job } = useJobDetailsContext()
  const { company } = useCurrentSession()
  const { referralsEnabled } = useAtsContext()
  const { featureAvailability } = useFeatureAvailability(Features.ats_vonq)
  const hasJobBoardsEnabled = featureAvailability.available

  const { data: integrationsData } = useGetMarketplaceIntegrations({
    datoIds: [integrationCodes.infojobs, integrationCodes.indeed],
  })

  const { data: companyInstallationsData } = useGetMarketplaceCompanyInstallations(
    {
      companyIds: [company.id],
    },
    false
  )

  const installedIntegrations = integrationsData.reduce((acc: AtsIntegrations, current) => {
    const integration = companyInstallationsData.find((i) => i.integrationId === current.id)
    if (!integration) return acc

    acc[current.name.toLocaleLowerCase()] = integration
    return acc
  }, {})

  return (
    <JobPostingLayout job={job}>
      <Box gap="s48" paddingX="s64">
        {referralsEnabled && <OpenPositions job={job} />}
        {hasJobBoardsEnabled && (
          <>
            <VonqCampaigns jobId={job.id} />
            <VonqImportedContracts job={job} />
          </>
        )}
        {hasJobBoards(job.isPublished) && (
          <JobBoards job={job} installedIntegrations={installedIntegrations} />
        )}
      </Box>
    </JobPostingLayout>
  )
}

export default JobPostingPromotion
